<template>
  <div class="api-permission-container">
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="filterForm" label-align="left">
        <a-grid :cols="4" :col-gap="26" :row-gap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item field="apiKey" label="API Key" label-col-flex="80px">
              <a-input v-model="filterForm.apiKey" placeholder="请输入API Key" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item field="systemName" label="对接系统名称" label-col-flex="100px">
              <a-input v-model="filterForm.systemName" placeholder="请输入对接系统名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item field="enabled" label="是否启用" label-col-flex="80px">
              <a-select v-model="filterForm.enabled" placeholder="请选择状态" allow-clear>
                <a-option value="">全部</a-option>
                <a-option :value="true">启用</a-option>
                <a-option :value="false">禁用</a-option>
              </a-select>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <a-space>
              <a-button type="primary" @click="handleQuery" :loading="loading">
                <template #icon>
                  <icon-search style="stroke: #fff"/>
                </template>
                搜索
              </a-button>
              <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
              <a-button type="text" @click="()=>{collapsed = !collapsed}">
                <template #icon>
                  <icon-down v-if="collapsed"/>
                  <icon-up v-else/>
                </template>
                {{ collapsed ? '展开' : '收起' }}
              </a-button>
            </a-space>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>

    <a-space/>

    <!-- API权限列表 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <template #header>
        <a-row>
          <a-col flex="200px">
            <span class="glass-card__title">API权限列表</span>
          </a-col>
          <a-col flex="auto"/>
          <a-col flex="150px">
            <a-row>
              <a-button type="outline" @click="handleAdd">
                <template #icon>
                  <icon-plus style="stroke: #fff"/>
                </template>
                新增
              </a-button>
              <a-tooltip content="列设置">
                <a-button type="text" @click="showColumnSetting = true">
                  <template #icon>
                    <icon-settings/>
                  </template>
                </a-button>
              </a-tooltip>
              <a-tooltip content="刷新">
                <a-button type="text" @click="fetchTableData">
                  <template #icon>
                    <icon-refresh/>
                  </template>
                </a-button>
              </a-tooltip>
            </a-row>
          </a-col>
        </a-row>
      </template>

      <!-- API权限列表表格 -->

      <a-table
          row-key="id"
          v-bind:columns="visibleColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :scroll="{ x: 1000 }"
      >
        <template #enabled="{ record }">
          <a-tag :color="record.enabled ? 'green' : 'red'">
            {{ record.enabled ? '启用' : '禁用' }}
          </a-tag>
        </template>
        <template #customerIds="{ record }">
           <span v-if="record.customerIds && record.customerIds.length > 0">
                {{ getCustomerNames(record.customerIds) }}
              </span>
          <span v-else>-</span>
        </template>
        <template #action="{ record }">
          <a-space>
            <a-button type="text" size="mini" status="warning" class="button-table-option" @click="handleEdit(record)">
              <template #icon>
                <icon-edit/>
              </template>
              修改
            </a-button>
            <a-button type="text" size="mini" status="success" class="button-table-option" @click="handleTest(record)">
              <template #icon>
                <icon-send/>
              </template>
              测试
            </a-button>
            <!-- 更多 -->
            <a-dropdown trigger="click">
              <a-button type="text" size="mini" class="button-table-option">更多</a-button>
              <template #content>
                <a-doption @click="handleDelete(record)">
                  <a-button type="text" size="mini" status="danger" class="button-table-option">
                    <template #icon>
                      <icon-delete/>
                    </template>
                    删除
                  </a-button>
                </a-doption>
              </template>
            </a-dropdown>
          </a-space>
        </template>
      </a-table>

      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          :current="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>

    <!-- 编辑/新增对话框 -->
    <a-modal
        :visible="dialogVisible"
        :title="dialogTitle"
        :mask-closable="false"
        @ok="submitForm"
        @cancel="handleDialogClose"
        @close="handleDialogClose"
        width="800px"
    >
      <a-form :model="form" :rules="rules" ref="formRef" :auto-label-width="true">
        <a-form-item field="systemName" label="对接系统名称" required>
          <a-input v-model="form.systemName" placeholder="请输入对接系统名称"/>
        </a-form-item>
        <a-form-item field="apiKey" label="API Key">
          <a-input v-model="form.apiKey" :disabled="true" placeholder="系统自动生成"/>
        </a-form-item>
        <a-form-item field="customerIds" label="客户列表">
          <a-select
              v-model="form.customerIds"
              :options="customerOptions"
              placeholder="请选择客户"
              multiple
              allow-clear
              :allow-search="{ retainInputValue: false }"
              :virtual-list-props="{ height: 300 }">
          </a-select>
        </a-form-item>
        <a-form-item field="customerNamePattern" label="客户名称匹配" :rules="customerNamePatternRules">
          <a-input
              v-model="form.customerNamePattern"
              placeholder="请输入客户名称匹配正则表达式"
          />
        </a-form-item>
        <a-alert banner style="margin-bottom: 10px;">如果不选择任何字段，则默认允许访问所有字段</a-alert>
        <a-form-item field="allowedFields" label="允许访问字段">
          <a-tree-select
              ref="treeRef"
              :data="fieldList"
              v-model:model-value="form.allowedFields"
              multiple
              allow-clear
              tree-checkable
              :tree-props="{ showLine: true }"
              placeholder="请选择允许访问的字段，不选则默认允许访问所有字段"
              style="flex: 1;"
          >
          </a-tree-select>
        </a-form-item>
        <a-form-item field="enabled" label="是否启用" required>
          <a-switch v-model="form.enabled"/>
        </a-form-item>
        <a-form-item field="description" label="描述">
          <a-textarea
              v-model="form.description"
              placeholder="请输入描述信息"
              :auto-size="{ minRows: 2 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 接口测试对话框 -->
    <a-modal
        :visible="testModalVisible"
        title="接口测试"
        @cancel="handleTestModalClose"
        @close="handleTestModalClose"
        width="800px"
        :footer="false"
    >
      <a-form :auto-label-width="true">
        <a-form-item field="endpoint" label="测试接口">
          <a-select v-model="selectedTestEndpoint" :options="testEndpoints" placeholder="请选择要测试的接口"
                    @change="onEndpointChange"/>
        </a-form-item>
        <a-form-item field="requestParams" label="请求参数">
          <a-textarea
              v-model="testRequestParams"
              placeholder='请输入JSON格式的请求参数'
              :auto-size="{ minRows: 3, maxRows: 6 }"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="testApiEndpoint">测试接口</a-button>
        </a-form-item>
      </a-form>

      <div style="margin-top: 10px; max-height: 300px; overflow-y: auto;">
        <div v-if="testResults.loading">测试中...</div>
        <div v-else-if="testResults.success"
             style="background-color: #f6ffed; border: 1px solid #b7eb8f; padding: 8px; border-radius: 4px;">
          <div><strong>状态:</strong> 成功</div>
          <div><strong>响应:</strong></div>
          <pre style="background-color: #fff; padding: 8px; border-radius: 4px; max-height: 200px; overflow-y: auto;">{{
              JSON.stringify(testResults.data, null, 2)
            }}</pre>
        </div>
        <div v-else-if="testResults.error"
             style="background-color: #fff2f0; border: 1px solid #ffccc7; padding: 8px; border-radius: 4px;">
          <div><strong>状态:</strong> 失败</div>
          <div><strong>错误信息:</strong>
            <span v-if="testResults.error.response">
              HTTP {{ testResults.error.response.status }}: {{ testResults.error.response.statusText }}
            </span>
            <span v-else>{{ testResults.error.message }}</span>
          </div>
          <div v-if="testResults.error.response && testResults.error.response.data">
            <strong>详细信息:</strong>
            <pre style="background-color: #fff; padding: 8px; border-radius: 4px; max-height: 200px; overflow-y: auto;">{{
                JSON.stringify(testResults.error.response.data, null, 2)
              }}</pre>
          </div>
        </div>
      </div>
    </a-modal>

    <!-- 列设置模态框 -->
    <a-drawer
        :visible="showColumnSetting"
        title="列设置"
        @ok="handleColumnSettingOk"
        @cancel="showColumnSetting = false"
        width="300px"
        :mask-closable="false"
        :hide-cancel="true"
    >
      <div class="column-setting">
        <a-checkbox-group v-model="selectedColumns" direction="vertical">
          <a-checkbox
              v-for="column in allColumns"
              :key="column.dataIndex"
              :value="column.dataIndex"
              :disabled="column.required"
          >
            {{ column.title }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-drawer>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref, watch} from 'vue'
import {
  addApiPermission,
  deleteApiPermission,
  getApiPermissionFields,
  getApiPermissionPage,
  updateApiPermission
} from '@/apis/system/api-permission'
import {getCustomerList} from '@/apis/customer-data'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import {
  IconDelete,
  IconDown,
  IconEdit,
  IconPlus,
  IconRefresh,
  IconSearch,
  IconSettings,
  IconUp,
  IconSend
} from '@arco-design/web-vue/es/icon'
import {Message, Modal as ArcoModal} from "@arco-design/web-vue";
import axios from 'axios'

// 条件查询表单折叠
const collapsed = ref(true)

// 对话框相关
const dialogVisible = ref(false)
const dialogTitle = ref('')

// 测试模态框相关
const testModalVisible = ref(false)
const currentTestApiKey = ref('')
const selectedTestEndpoint = ref('/customer')
const testRequestParams = ref(JSON.stringify({
  customerId: "",
  pageIndex: 1,
  pageSize: 20
}, null, 2))

// 测试结果相关
const testResults = reactive({
  loading: false,
  success: false,
  data: null,
  error: null
})

// 可测试的接口选项
const testEndpoints = [
  {value: '/customer', label: '获取客户接口 (/customer)'},
  {value: '/customer/store', label: '获取门店接口 (/customer/store)'},
  {value: '/workorder', label: '获取工单接口 (/workorder)'}
]

// 不同接口的默认参数
const getDefaultParams = (endpoint) => {
  switch (endpoint) {
    case '/customer':
      return JSON.stringify({
        customerId: "",
        pageIndex: 1,
        pageSize: 20
      }, null, 2)
    case '/customer/store':
      return JSON.stringify({
        customerId: "",
        storeId: "",
        pageIndex: 1,
        pageSize: 20
      }, null, 2)
    case '/workorder':
      return JSON.stringify({
        customerId: "",
        storeId: "",
        workOrderId: "",
        pageIndex: 1,
        pageSize: 20
      }, null, 2)
    default:
      return '{}'
  }
}

// 是否编辑模式
const isEdit = ref(false)

// 列设置相关
const showColumnSetting = ref(false)
const selectedColumns = ref([
  'apiKey',
  'systemName',
  'customerIds',
  'enabled',
  'description',
  'action'
])

// 筛选条件
const filterForm = reactive({
  apiKey: '',
  systemName: '',
  enabled: ''
})

// 表单数据
const form = reactive({
  id: '',
  apiKey: '',
  systemName: '',
  customerIds: [],
  customerNamePattern: '',
  allowedFields: [],
  deniedFields: [],
  enabled: true,
  description: ''
})

// 表单验证规则
const rules = {
  systemName: [
    {required: true, message: '请输入对接系统名称'}
  ],
  enabled: [
    {required: true, message: '请选择启用状态'}
  ]
}

// customerNamePattern字段的独立验证规则
const customerNamePatternRules = [
  {
    validator: (value, cb) => {
      if ((!form.customerIds || form.customerIds.length === 0) && !form.customerNamePattern) {
        cb('客户列表和客户名称匹配至少填写一个')
      } else {
        cb(null)
      }
    }
  }
]

// 表单引用
const formRef = ref()

// 客户列表
const customerList = ref([])

// 字段选项列表
const fieldList = ref([])

// 客户选项
const customerOptions = computed(() => {
  return customerList.value.map(item => ({value: item.id, label: item.customerName}))
})

// 字段选项
const fieldOptions = computed(() => {
  // 根据接口返回的数据结构提取字段信息
  if (fieldList.value && Array.isArray(fieldList.value) && fieldList.value.length > 0) {
    // 假设接口返回的是字段名数组
    if (typeof fieldList.value[0] === 'string') {
      return fieldList.value.map(item => ({value: item, label: item}))
    }
    // 如果是对象数组，包含 fieldName 和 description
    else if (fieldList.value[0].fieldName) {
      return fieldList.value.map(item => ({value: item.fieldName, label: item.description || item.fieldName}))
    }
  }
  return []
})

// 所有列定义
const allColumns = ref([
  {title: 'API Key', dataIndex: 'apiKey', width: 150, ellipsis: true, required: true},
  {title: '对接系统名称', dataIndex: 'systemName', width: 150, ellipsis: true},
  {title: '客户列表', dataIndex: 'customerIds', width: 150, slotName: 'customerIds'},
  {title: '客户名称匹配', dataIndex: 'customerNamePattern', width: 150},
  {title: '是否启用', dataIndex: 'enabled', width: 80, slotName: 'enabled'},
  {title: '操作', dataIndex: 'action', width: 100, fixed: 'right', required: true, slotName: 'action'}
])

// 可见列计算属性
const visibleColumns = computed(() => {
  return allColumns.value.filter(column => selectedColumns.value.includes(column.dataIndex))
})

// API权限列表数据
const pagination = reactive({
  records: [],
  currentPage: 1,
  pageSize: 10,
  total: 0
})

// 加载状态
const loading = ref(false)

// 监听客户相关字段变化，触发验证
watch([() => form.customerIds, () => form.customerNamePattern], () => {
  if (formRef.value) {
    formRef.value.validateField('customerNamePattern')
  }
})

// 获取客户列表
const fetchCustomerList = async () => {
  try {
    const res = await getCustomerList()
    if (res.code === 0) {
      customerList.value = res.data
    } else {
      Message.error(res.message || '获取客户列表失败')
    }
  } catch (error) {
    Message.error('获取客户列表失败: ' + error.message)
  }
}

// 获取字段列表
const fetchFieldList = async () => {
  try {
    const res = await getApiPermissionFields()
    if (res.code === 0) {
      // 处理接口返回的数据格式
      if (Array.isArray(res.data)) {
        // 如果返回的是包含类信息的对象数组
        // if (res.data.length > 0 && res.data[0].fieldInfos) {
        // 提取所有类中的字段信息
        //   const allFields = []
        //   res.data.forEach(classInfo => {
        //     if (classInfo.fieldInfos && Array.isArray(classInfo.fieldInfos)) {
        //       classInfo.fieldInfos.forEach(field => {
        //         // 避免重复添加相同的字段
        //         if (!allFields.some(f => f.fieldName === field.fieldName)) {
        //           allFields.push(field)
        //         }
        //       })
        //     }
        //   })
        //   fieldList.value = allFields
        // } else {
        // 如果返回的是简单字段数组
        fieldList.value = res.data
        // }
      }
    } else {
      Message.error(res.message || '获取字段列表失败')
    }
  } catch (error) {
    Message.error('获取字段列表失败: ' + error.message)
  }
}

// 获取API权限列表
const fetchTableData = async () => {
  loading.value = true
  try {
    const res = await getApiPermissionPage(
        pagination.currentPage,
        pagination.pageSize,
        filterForm
    )

    if (res.code === 0) {
      // 处理客户ID列表，将逗号分隔的字符串转为数组
      const processedRecords = res.data.records.map(item => {
        return {
          ...item,
          customerIds: Array.isArray(item.customerIds)
              ? item.customerIds
              : (item.customerIds && item.customerIds !== "" ? item.customerIds.split(',') : []),
          allowedFields: Array.isArray(item.allowedFields)
              ? item.allowedFields
              : (item.allowedFields && item.allowedFields !== "" ? item.allowedFields.split(',') : []),
          // deniedFields: item.deniedFields && typeof item.deniedFields === 'string' ? JSON.parse(item.deniedFields) : (Array.isArray(item.deniedFields) ? item.deniedFields : [])
        }
      })

      pagination.records = processedRecords
      pagination.total = res.data.total
    } else {
      console.log(res)
      Message.error(res.message || '获取数据失败')
    }
  } catch (error) {
    Message.error('获取数据失败: ' + error.message)
  } finally {
    loading.value = false
  }
}

// 搜索
const handleQuery = () => {
  pagination.currentPage = 1
  fetchTableData()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(filterForm).forEach(key => {
    filterForm[key] = ''
  })
  fetchTableData()
}

// 处理页码变化
const handlePageChange = (page) => {
  pagination.currentPage = page
  fetchTableData()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.pageSize = size
  pagination.currentPage = 1
  fetchTableData()
}

// 获取客户名称
const getCustomerNames = (customerIds) => {
  if (!customerIds || customerIds.length === 0) return '-'

  const names = customerIds.map(id => {
    const customer = customerList.value.find(c => c.id === id)
    return customer ? customer.customerName : id
  })

  return names.join(', ')
}

// 新增
const handleAdd = () => {
  dialogTitle.value = '新增API权限'
  isEdit.value = false
  resetForm()
  dialogVisible.value = true
}

// 编辑
const handleEdit = (record) => {
  dialogTitle.value = '编辑API权限'
  isEdit.value = true
  // 处理客户ID列表，将逗号分隔的字符串转为数组
  const processedRecord = {
    ...record,
    customerIds: Array.isArray(record.customerIds)
        ? record.customerIds
        : (record.customerIds && record.customerIds !== "" ? record.customerIds.split(',') : []),
    allowedFields: Array.isArray(record.allowedFields)
        ? record.allowedFields
        : (record.allowedFields && record.allowedFields !== "" ? record.allowedFields.split(',') : []),
    // deniedFields: record.deniedFields ? JSON.parse(record.deniedFields) : []
  }
  Object.assign(form, processedRecord)
  dialogVisible.value = true
}

// 删除
const handleDelete = (record) => {
  ArcoModal.confirm({
    title: '提示',
    content: `确认要删除对接系统名称为 "${record.systemName}"，API Key为 "${record.apiKey}" 的权限配置吗？`,
    okText: '确认',
    cancelText: '取消',
    onOk: async () => {
      try {
        const res = await deleteApiPermission(record.id)
        if (res.code === 0) {
          Message.success('删除成功')
          await fetchTableData()
        } else {
          Message.error(res.message || '删除失败')
        }
      } catch (error) {
        Message.error('删除失败: ' + error.message)
      }
    }
  })
}

// 接口测试
const handleTest = async (record) => {
  currentTestApiKey.value = record.apiKey;
  testModalVisible.value = true;
};

// 当切换测试接口时更新默认参数
const onEndpointChange = (value) => {
  testRequestParams.value = getDefaultParams(value);
};

// 关闭测试模态框
const handleTestModalClose = () => {
  testModalVisible.value = false;
  // 清空测试结果
  setTimeout(() => {
    testResults.loading = false;
    testResults.success = false;
    testResults.data = null;
    testResults.error = null;
  }, 300); // 延迟清空以确保动画完成
};

// 测试API端点
const testApiEndpoint = async () => {
  const endpoint = selectedTestEndpoint.value;
  const apiKey = currentTestApiKey.value;
  let requestData = {};

  // 尝试解析用户输入的请求参数
  try {
    if (testRequestParams.value.trim()) {
      requestData = JSON.parse(testRequestParams.value);
    }
  } catch (e) {
    Message.error('请求参数格式错误，请输入有效的JSON格式');
    return;
  }

  // 重置测试结果
  testResults.loading = true;
  testResults.success = false;
  testResults.data = null;
  testResults.error = null;

  try {
    var baseUrl = location.origin === "https://admin.ry.ruijinnetwork.com" ? "https://api.ry.ruijinnetwork.com" : "";
    // 使用axios直接发送请求
    const response = await axios.post(`${baseUrl}${endpoint}`, requestData, {
      headers: {
        'key': apiKey
      },
      timeout: 30000 // 30秒超时
    });

    testResults.success = true;
    testResults.data = response.data;
  } catch (error) {
    testResults.error = error;
  } finally {
    testResults.loading = false;
  }
};

// 重置表单
const resetForm = () => {
  Object.keys(form).forEach(key => {
    if (key === 'enabled') {
      form[key] = true
    } else if (key === 'customerIds') {
      form[key] = []
    } else if (key === 'allowedFields' || key === 'deniedFields') {
      form[key] = []
    } else {
      form[key] = ''
    }
  })
}

// 关闭对话框
const handleDialogClose = () => {
  dialogVisible.value = false
  formRef.value?.resetFields()
}

// 提交表单
const submitForm = () => {
  formRef.value?.validate(async (errors) => {
    if (!errors) {
      try {
        // 处理表单数据，将数组转为JSON字符串
        const formData = {
          ...form,
          customerIds: Array.isArray(form.customerIds) ? form.customerIds.join(',') : form.customerIds,
          allowedFields: Array.isArray(form.allowedFields) ? form.allowedFields.join(',') : form.allowedFields,
          deniedFields: Array.isArray(form.deniedFields) ? form.deniedFields.join(',') : form.deniedFields
        }

        let res
        if (isEdit.value) {
          // 编辑
          res = await updateApiPermission(formData)
        } else {
          // 新增
          res = await addApiPermission(formData)
        }

        if (res.code === 0) {
          Message.success(isEdit.value ? '更新成功' : '新增成功')
          handleDialogClose()
          await fetchTableData()
        } else {
          Message.error(res.message || (isEdit.value ? '更新失败' : '新增失败'))
        }
      } catch (error) {
        Message.error((isEdit.value ? '更新失败' : '新增失败') + ': ' + error.message)
      }
    }
  })
}

// 列设置相关方法
const handleColumnSettingOk = () => {
  showColumnSetting.value = false
  // 保存用户的列设置到本地存储
  localStorage.setItem('apiPermissionListColumns', JSON.stringify(selectedColumns.value))
  Message.success('列设置保存成功')
}

// 组件挂载时获取数据
onMounted(() => {
  // 从本地存储加载列设置
  const savedColumns = localStorage.getItem('apiPermissionListColumns')
  if (savedColumns) {
    try {
      selectedColumns.value = JSON.parse(savedColumns)
    } catch (e) {
      console.warn('Failed to parse saved columns:', e)
    }
  }

  fetchTableData()
  fetchCustomerList()
  fetchFieldList()
})
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}

.button-table-option {
  padding: 0;
}
</style>